/** Verified EWS source-key layout, used only to label already-authorized own group members. */
export function contactReference(id: string): string | undefined {
  try {
    const bytes = atob(id.replace(/-/g, '+').replace(/_/g, '/'));
    if (bytes.length !== 70) return undefined;
    return `urn:uuid:${[...bytes.slice(46, 68)].map(byte => byte.charCodeAt(0).toString(16).padStart(2, '0')).join('')}`;
  } catch { return undefined; }
}
